import { render, staticRenderFns } from "./MenuItemsV3Mod.vue?vue&type=template&id=33fea771"
import script from "./MenuItemsV3Mod.vue?vue&type=script&lang=js"
export * from "./MenuItemsV3Mod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports